import axios from "axios"
import accessToken from "./jwt-token-access/accessToken"

//pass new generated access token here
const token = accessToken

//apply base url for axios
const API_URL = ""

const axiosApi = axios.create({
  baseURL: API_URL,
})

// Get token dynamically from localStorage
axiosApi.interceptors.request.use(
  config => {
    // Get token from localStorage (same as other pages in the app)
    let token = localStorage.getItem('token')

    // console.log('[API Helper] Request URL:', config.url)
    // console.log('[API Helper] Token from localStorage:', token ? 'Found' : 'Not found')

    if (token) {
      // Backend expects 'x-access-token' header, not 'Authorization'
      config.headers['x-access-token'] = token
      // console.log('[API Helper] x-access-token header set')
    } else {
      console.log('[API Helper] No token, header NOT set')
    }

    return config
  },
  error => Promise.reject(error)
)

axiosApi.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
)

export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
}
